/**
 * 登出會員並清除驗證 TOKEN
 */
import { memberSignout } from '@/api/members'
import { broadcastSessionEvent } from './useSessionBroadcast'

interface LogoutOptions {
  /** 只清除登入資訊，不打 signout API、不送 tracker、不廣播跨分頁事件（給跨分頁同步登出用） */
  eraseOnly?: boolean
}

export const useLogout = async (options: LogoutOptions = {}) => {
  const currentMember = useMember()
  const authorization = useAuthorization()
  const session = useState('currentSession', () => null)
  const pagePermission = usePagePermission()
  const routeBeforeLogin = useCookie<string>('routeBeforeLogin')

  // 只清除登入資訊
  if (options.eraseOnly) {
    currentMember.value = null
    authorization.value = null
    session.value = null
    routeBeforeLogin.value = ''
    return
  }

  // 清除 session
  memberSignout()

  // 先清除前端登入狀態，避免追蹤或瀏覽器 extension 的錯誤卡住 UI
  currentMember.value = null
  authorization.value = null
  session.value = null
  routeBeforeLogin.value = ''

  // GA: 使用者手動登出
  const { gtag } = useGtag()
  gtag('event', 'logout', {
    user_id: null
  })

  // Tracker: 使用者手動登出
  const tracker = useEventTracker()
  tracker.sendEvent('logout')

  // 通知其他分頁同步登出（其他分頁會跑 eraseOnly 路徑，不會再廣播一次）
  broadcastSessionEvent('logout')

  // 如果當前頁面需要登入
  if (pagePermission.value) {
    await navigateTo(useLocalePath()('/')) // 回到首頁
  }

}
